import { Lock, Globe } from "lucide-react"

import { Button } from "@ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

interface AgentAccessModeBadgeProps {
    disabled?: boolean
    value: "private" | "shared"
    onChange: (value: boolean) => void
}
export function AgentAccessModeBadge({ disabled = false, value, onChange }: Readonly<AgentAccessModeBadgeProps>) {
    const handleSharedModeChange = () => {
        const isShared = value === "shared"
        onChange(!isShared)
    }

    return (
        <div>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button variant="icon" size="icon" onClick={handleSharedModeChange} className={`${value === "shared" ? "bg-gray-950 text-white hover:bg-gray-550 hover:text-white" : ""}`} disabled={disabled}>
                            {value === "shared" ? <Globe /> : <Lock />}
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>{value === "shared" ? "Shared" : "Private"} Conversation</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    )
}
